import React, { useEffect, useState, useRef, useCallback } from 'react';
import EnhancedTableToolbar from '../../../sharedcomponents/tableToolbar/tableToolbar';
import {
    Box,
    List,
    ListItem,
    Card,
    CardContent,
    Typography,
    Checkbox,
} from '@mui/material';
import { createTheme } from '@mui/material/styles';
import { makeStyles, styled } from '@mui/styles';
import DataListRow from './dataListRow';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import moment from 'moment';
import UserList from './userList';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import LibraryAddIcon from '@mui/icons-material/LibraryAdd';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import { VariableSizeList as LoadDataList } from "react-window";
import AutoSizer from "react-virtualized-auto-sizer";
import { useThemeState } from '../../../hookState/ThemeState';
import Paging from '../../../sharedcomponents/pagination/pagination';
import Helper from '../../../utility/helper';
import { useWindowResize } from '../../../utility/useWindowResize';
import ScheduleRow from './scheduleRow';
import { Virtuoso } from 'react-virtuoso';
import { FULL_PERMISSION } from '../../../constants/Constant';
import CustomScheduleGrid from '../../../sharedcomponents/customDataGrid/customschedulegrid';
import ScheduleDataGrid from './scheduleDataGrid';

const theme = createTheme();
const useStyles = makeStyles(() => ({
    listContent: {
        paddingBottom: theme.spacing(0),
        zIndex: 0,
    },
    cardContent: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0,
        },
    },
    rowContent: {
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
    },
    listItemContent: {
        padding: theme.spacing(1, 0),
    },
    paperContent: {
        boxShadow:
            '0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12)', // made the changes for consistent styling
        borderRadius: theme.spacing(2),
        padding: theme.spacing(1),
        backgroundColor: '#fff',
        border: '1px solid #efefef',
    },
    accordionMain: {
        '& .MuiButtonBase-root': {
            '& .Mui-expanded': {
                minHeight: theme.spacing(4),
            },
        },
    },
    accordion: {
        backgroundColor: '#cccccc',
    },
    accordionHeader: {
        textTransform: 'uppercase',
        fontWeight: 600,
        color: 'white',
    },
    addTopPad: {
        padding: theme.spacing(0.5),
    },
}));

const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(() => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&:before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(() => ({
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(180deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(() => ({
    padding: '0 16px',
}));

export default function DataList(props) {
    const classes = useStyles();
    const themeState = useThemeState();

    const [listData, setListData] = useState(null);
    const [selectedUser, setSelectedUser] = useState(0);
    const [participants, setParticipants] = useState([]);

    const [dates, setDates] = useState(null);
    const [expanded, setExpanded] = React.useState([]);
    const [selectAllFlag, setSelectAllFlag] = React.useState(false);
    const [selectedUserName, setSelectedUserName] = useState('');
    const [checkAllSelect, setCheckAllSelect] = React.useState(false);

    const userInfo = Helper.getStorage('userInfo');
    const toggleButtonList = [
        {
            title: 'Create New',
            onClick: () => props.handleClick(selectedUser),
            icon: <AddCircleOutlineIcon />,
        },
        {
            title: 'Add Existing',
            onClick: () => props.openActivityListDialog(selectedUser),
            icon: <LibraryAddIcon />,
        },
    ];

    const listRef = useRef();
    const sizeMap = useRef({});
    const setSize = useCallback((index, size) => {
        sizeMap.current = { ...sizeMap.current, [index]: size };
        listRef.current.resetAfterIndex(index);
    }, []);
    const getSize = index => sizeMap.current[index] || 60;
    const [windowWidth] = useWindowResize();

    const handleChange = (index) => (event, isExpanded) => {
        let newExpanded = [...expanded];
        newExpanded[index] = isExpanded;
        setExpanded(newExpanded);
    };
    function getDates(startDate, endDate) {
        const dates = [];
        let currentDate = startDate;
        const addDays = function (days) {
            const date = new Date(this.valueOf());
            date.setDate(date.getDate() + days);
            return date;
        };
        while (currentDate <= endDate) {
            dates.push(moment(currentDate).format('MM/DD/YYYY'));
            currentDate = addDays.call(currentDate, 1);
        }
        return dates;
    }

    useEffect(() => {
        if (props.selectAllFlag === true) {
            setSelectAllFlag(true);
        }
    }, [props.selectAllFlag])

    useEffect(() => {
        if (props.submitPublishUnpublished) {
            setCheckAllSelect(false);
            if (props.setSubmitPublishUnpublished)
                props.setSubmitPublishUnpublished(false);
        }
    }, [props.submitPublishUnpublished]);

    useEffect(() => {
        if (props.data.length > 0) {
            if (!props.showUsersList) {
                getDistinctDates([...props.data]);
                setListData([...props.data]);

            } else {
                let user = selectedUser;
                let participantsList = [];
                //if (user === 0) {

                let userIds = [];
                let subActPartiIds = []
                props.data.forEach((element) => {
                    let ids = element.actualData.participants.map(
                        (x) => x.userID
                    );

                    element.actualData.subActivities && element.actualData.subActivities.length > 0 && element.actualData.subActivities.map(
                        (x) => x.subActivityParticipants && x.subActivityParticipants.length > 0 && x.subActivityParticipants.map(
                            (y) => subActPartiIds.push(y.userID)
                        )
                    );
                    userIds = userIds.concat(ids);
                });
                const newMergedArr = userIds.concat(subActPartiIds);
                userIds = [...new Set(newMergedArr)];
                participantsList = props.participants.filter((x) =>
                    userIds.includes(x.userID)
                );
                // console.log("participantsList",participantsList);
                // let index = participantsList.findIndex(
                //     (x) => x.userID === user
                // );
                // let userIndex = index === -1 ? 0 : index;
                // console.log("userIndex",userIndex);
                // user =
                //     participantsList.length > 0
                //         ? participantsList[userIndex].userID
                //         : 0;
                // }
                // console.log("user", user, "props.showTabUser", props.showTabUser);
                if (user === 0) {
                    setParticipants(props.showTabUser);
                    // setParticipants((getAllUserIds.length > 0) ? props.participants : props.showTabUser);
                }
                // let data = props.data.filter((x) =>
                //     x.actualData.participants
                //         .map((y) => y.userID)
                //         .some((z) => user === z)
                // );
                // console.log("new dta", data);
                setListData(props.data);
                getDistinctDates(props.data);
                setSelectedUser(user);
                if (user && participantsList.length > 0) {
                    onSelectedUser(user, props.participants);
                }
            }
        } else {
            setDates([]);
            setListData([]);
            setParticipants([]);
        }
    }, [props.data, props.participants]);

    useEffect(() => {
        if (props.gridFilters && props.data && props.data.length > 0) {
            let isAllNotChecked = props.data.some((item) => !item.selected);
            if (!isAllNotChecked) {
                setCheckAllSelect(true);
            } else {
                setCheckAllSelect(false);
            }
        }

    }, [props.gridFilters, props.data])

    const getDistinctDates = (data) => {
        let activityDates = [];
        data.map((item) => {
            let startDate =
                item.actualData.startDateTime !== null
                    ? moment(item.actualData.startDateTime).format('MM/DD/YYYY')
                    : null;
            let endDate = null; //item.actualData.endDateTime !== null ? moment(item.actualData.endDateTime).format('MM/DD/YYYY') : null;
            let range = [];
            if (startDate !== null && endDate !== null) {
                range = getDates(moment(startDate), moment(endDate));
            } else if (startDate !== null && endDate === null) {
                range = [startDate];
            } else if (startDate === null && endDate !== null) {
                range = [endDate];
            } else {
                range = ['TBD'];
            }
            //let range = getDates(moment(startDate), moment(endDate))

            activityDates = [...activityDates, ...range];
        });
        let uniqueDates = [...new Set(activityDates)];
        let TBDindex = uniqueDates.indexOf('TBD');
        if (TBDindex > -1) {
            uniqueDates.splice(TBDindex, 1);
            uniqueDates = uniqueDates.sort((a, b) => moment(a) - moment(b));
            uniqueDates.unshift('TBD');
        } else {
            uniqueDates = uniqueDates.sort((a, b) => moment(a, "MM/DD/YYYY") - moment(b, "MM/DD/YYYY"));
        }
        setDates(uniqueDates);
        setExpanded(uniqueDates.map(() => true));
    };

    const onCheckSelect = (event, item) => {
        let newFilterList = [...listData];
        let index = newFilterList.findIndex(
            (x) => x.actualData.activityID === item.actualData.activityID
        );
        if (index > -1) {
            newFilterList[index]['selected'] = event.target.checked;
            setListData(newFilterList);
        }

        let isAllNotChecked = newFilterList.some((item) => !item.selected);
        if (!isAllNotChecked) {
            setCheckAllSelect(true);
        } else {
            setCheckAllSelect(false);
        }
    };

    const onCheckSelectAll = (e) => {
        let newFilterList = [...listData];
        newFilterList.map((item) => {
            return (item.selected = e.target.checked);
        });
        setCheckAllSelect(e.target.checked);
        setListData(newFilterList);
    };


    const handleUserClick = (id) => {
        let data = props.data.filter((x) =>
            x.actualData.participants.map((y) => y.userID).some((z) => id === z)
        );
        setListData(data);
        getDistinctDates(data);
        setSelectedUser(id);
        props.fetchActivities(id)
        props.activeUserId(id);
    };

    const deleteUserActivities = () => {
        let data = listData.filter((x) => x.selected === true);
        props.handleActivitiesDelete(
            selectedUser,
            data.map((x) => x.actualData.activityID)
        );
    };

    const onSelectedUser = (userId, participantList) => {
        let users = participantList;
        let selectedItem = users.filter((x) => x.userID === userId);
        setSelectedUserName(selectedItem[0].name);
    };

    const rowItemContent = (index, row) => {
        let date = dates[index];
        let list = [...listData];
        let actdata = list.filter((x) => {
            if (x.actualData.startDateTime !== null) {
                //&& x.actualData.endDateTime !== null
                if (
                    moment(date).format('MM/DD/YYY') ==
                    moment(
                        x.actualData.startDateTime
                    ).format('MM/DD/YYY')
                ) {
                    //&& moment(date).format('MM/DD/YYY') <= moment(x.actualData.endDateTime).format('MM/DD/YYY')
                    return x;
                }
            } else if (
                date === 'TBD' &&
                x.actualData.startDateTime === null &&
                x.actualData.endDateTime === null
            )
                return x;
        });

        return (
            <div key={`list_date_${index}`} className={classes.addTopPad}>
                <Accordion
                    key={index}
                    expanded={expanded[index]}
                    onChange={handleChange(index)}>
                    {/* expanded={expanded === `panel${index + 1}`} onChange={handleChange(`panel${index + 1}`)} */}
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />}
                        aria-controls={`panel${index + 1
                            }bh-content`}
                        id={`panel${index + 1}bh-header`}
                        style={{ backgroundColor: themeState.primary.value }}>
                        <Typography
                            sx={{ width: '33%', flexShrink: 0 }}
                            className={classes.accordionHeader}>
                            {date !== 'TBD'
                                ? moment(date).format(
                                    'dddd, MMMM D, YYYY'
                                )
                                : date}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ mb: 2 }}>
                        <List className={classes.listContent}>
                            {actdata &&
                                actdata.length > 0 &&
                                actdata.map((actitem, actindex) => (
                                    <ScheduleRow
                                        key={`datarow_${index}_${actindex}`}
                                        item={actitem}
                                        index={actindex}
                                        onCheckSelect={
                                            onCheckSelect
                                        }
                                        handleAddParticipants={
                                            props.handleAddParticipants
                                        }
                                        handleViewParticipants={
                                            props.handleViewParticipants
                                        }
                                        editSubActivityRow={props.editSubActivityRow}
                                        editRow={props.editRow}
                                        viewPage={
                                            props.viewPage
                                        }
                                        deleteSubActivityRow={props.deleteSubActivityRow}
                                        showUsersList={
                                            props.showUsersList
                                        }
                                        handleAddSubActivity={props.handleAddSubActivity}
                                        showSubActivity={props.showSubActivity}
                                        modPermission={
                                            props.modPermission
                                        }
                                        onRowToggleChange={
                                            props.onRowToggleChange
                                        }
                                        showUserActivity={props.showPdfExport}
                                        hideCheckBox={props.showPdfExport ? true : false}
                                    />
                                ))}
                        </List>
                    </AccordionDetails>
                </Accordion>
            </div>
        )
    }
    const Row = ({ data, index, setSize, windowWidth, showUserActivity }) => {
        const rowRef = useRef();
        useEffect(() => {
            setSize(index, rowRef.current.getBoundingClientRect().height);
        }, [setSize, index, windowWidth]);

        return (
            <div ref={rowRef} className={classes.addTopPad}>
                <ScheduleRow
                    key={`datarow_${index}`}
                    item={data[index]}
                    index={index}
                    onCheckSelect={
                        onCheckSelect
                    }
                    handleAddParticipants={
                        props.handleAddParticipants
                    }
                    handleViewParticipants={
                        props.handleViewParticipants
                    }
                    editSubActivityRow={props.editSubActivityRow}
                    editRow={props.editRow}
                    viewPage={
                        props.viewPage
                    }
                    deleteSubActivityRow={props.deleteSubActivityRow}
                    showUsersList={
                        props.showUsersList
                    }
                    handleAddSubActivity={props.handleAddSubActivity}
                    showSubActivity={props.showSubActivity}
                    modPermission={
                        props.modPermission
                    }
                    onRowToggleChange={
                        props.onRowToggleChange
                    }
                    showUserActivity={showUserActivity}
                    hideCheckBox={showUserActivity ? true : false}
                />

            </div>
        )
    }

    const DateRow = ({ data, index, setSize, windowWidth, showUserActivity }) => {
        const rowRef = useRef();
        useEffect(() => {
            setSize(index, rowRef.current.getBoundingClientRect().height);
        }, [setSize, index, windowWidth]);

        // const item = data[index];
        let date = data[index];
        let list = [...listData];

        let actdata = list.filter((x) => {
            if (x.actualData.startDateTime !== null) {
                //&& x.actualData.endDateTime !== null
                if (
                    moment(date).format('MM/DD/YYY') ==
                    moment(
                        x.actualData.startDateTime
                    ).format('MM/DD/YYY')
                ) {
                    //&& moment(date).format('MM/DD/YYY') <= moment(x.actualData.endDateTime).format('MM/DD/YYY')
                    return x;
                }
            } else if (
                date === 'TBD' &&
                x.actualData.startDateTime === null &&
                x.actualData.endDateTime === null
            )
                return x;
        });

        return (
            <div ref={rowRef} className={classes.addTopPad}>
                <Accordion
                    key={index}
                    expanded={expanded[index]}
                    onChange={handleChange(index)}>
                    {/* expanded={expanded === `panel${index + 1}`} onChange={handleChange(`panel${index + 1}`)} */}
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />}
                        aria-controls={`panel${index + 1
                            }bh-content`}
                        id={`panel${index + 1}bh-header`}
                        style={{ backgroundColor: themeState.primary.value }}>
                        <Typography
                            sx={{ width: '33%', flexShrink: 0 }}
                            className={classes.accordionHeader}>
                            {date !== 'TBD'
                                ? moment(date).format(
                                    'dddd, MMMM D, YYYY'
                                )
                                : date}
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails sx={{ mb: 2 }}>
                        <List className={classes.listContent}>
                            {actdata &&
                                actdata.length > 0 &&
                                actdata.map((actitem, actindex) => (
                                    <ScheduleRow
                                        key={`datarow_${index}_${actindex}`}
                                        item={actitem}
                                        index={actindex}
                                        onCheckSelect={
                                            onCheckSelect
                                        }
                                        handleAddParticipants={
                                            props.handleAddParticipants
                                        }
                                        handleViewParticipants={
                                            props.handleViewParticipants
                                        }
                                        editSubActivityRow={props.editSubActivityRow}
                                        editRow={props.editRow}
                                        viewPage={
                                            props.viewPage
                                        }
                                        deleteSubActivityRow={props.deleteSubActivityRow}
                                        showUsersList={
                                            props.showUsersList
                                        }
                                        handleAddSubActivity={props.handleAddSubActivity}
                                        showSubActivity={props.showSubActivity}
                                        modPermission={
                                            props.modPermission
                                        }
                                        onRowToggleChange={
                                            props.onRowToggleChange
                                        }
                                        showUserActivity={showUserActivity}
                                    />
                                ))}
                        </List>
                    </AccordionDetails>
                </Accordion>
            </div>
        )
    }

    const loadMore = useCallback(() => {
        return setTimeout(() => {
            if (listData.length > 100)
                setListData((listData) => [...listData, ...generateList(100, listData.length)])
        }, 500)
    }, [setListData]);

    function generateList(count, start) {
        return Array.from({ length: count }, (item) => (item))
    }

    const renderNoRecordsUI = () => {
        return (
            <ListItem className={classes.listItemContent}>
                <Card
                    classes={{ root: classes.paperContent }}
                    sx={{ width: '100%' }}>
                    <CardContent
                        sx={{ p: 2 }}
                        className={classes.cardContent}>
                        <Box className={classes.rowContent}>
                            No data found
                        </Box>
                    </CardContent>
                </Card>
            </ListItem>
        )
    }

    return (
        <Box component="div">
            <Box component="div" sx={{ display: 'flex' }}>
                {props.showUsersList && (
                    <Box
                        component="div"
                        sx={{
                            width: '20%',
                            padding: '0 8px',
                            display: 'flex',
                        }}>
                        <UserList
                            participants={participants}
                            handleUserClick={handleUserClick}
                            //listSelect={onListSelect}
                            //selectAll={onListSelectAll}
                            handleAddToPdfListArray={props.handleAddToPdfListArray}
                            allSelect={selectAllFlag ? true : false}
                            selected={selectedUser}
                        />
                    </Box>
                )}
                <Box
                    component="div"
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: props.showUsersList ? '80%' : '100%',
                    }}>
                    <EnhancedTableToolbar
                        {...props}
                        search={props.search}
                        handleSearchChange={props.handleOnChange}
                        import={
                            !props.showUsersList && props.import ? true : false
                        }
                        showSend={props.showUsersList ? true : false}
                        importbuttonTitle={
                            !props.showUsersList && props.import
                                ? 'Import'
                                : null
                        }
                        showMenuAdd={false}
                        hideEdit={true}
                        hideDelete={props.showUsersList ? true : false}
                        hideAdd={props.showUsersList ? true : false}
                        deleteRows={
                            props.showUsersList
                                ? deleteUserActivities
                                : props.deleteRows
                        }
                        toggleButtonList={toggleButtonList}
                        showSelectedUser={selectedUserName}
                        filterDates={props.filterDates}
                        gridFilters={props.gridFilters}
                        setGridFilters={props.setGridFilters}
                        adminSchedulePage={props.adminSchedulePage}
                        resetGridFilters={props.resetGridFilters}
                    />
                    {props.showForAdminOnly && <Box
                        sx={{
                            width: '100%',
                            ml: 1,
                            display: 'flex',
                        }}>
                        <Checkbox
                            // color="secondary"
                            checked={checkAllSelect}
                            className={
                                classes.checkbox_style
                            }
                            onChange={(e) =>
                                onCheckSelectAll(e)
                            }
                            value={checkAllSelect}
                        />

                        <Typography sx={{ mt: 1 }}>
                            Select All
                        </Typography>
                    </Box>}
                    {
                        props.modPermission == FULL_PERMISSION ?
                            // <CustomScheduleGrid
                            // <ScheduleDataGrid
                            //     dates={dates}
                            //     data={listData}
                            //     direction="ltr"
                            //     selectAllFlag={checkAllSelect}
                            //     onCheckSelect={
                            //         onCheckSelect
                            //     }
                            //     handleAddParticipants={
                            //         props.handleAddParticipants
                            //     }
                            //     handleViewParticipants={
                            //         props.handleViewParticipants
                            //     }
                            //     editRow={props.editRow}
                            //     showUserActivity={props.showPdfExport}
                            //     selectedUserName={selectedUserName}
                            //     filters={props.gridFilters}
                            //     setFilters={props.setGridFilters}
                            // />
                            <>
                                {
                                    listData && listData.length > 0 ?

                                        <div style={{ display: 'flex', height: '63vh' }}>
                                            <div style={{ flex: '1 1 auto' }}>
                                                <AutoSizer>
                                                    {({ height, width }) => (
                                                        <LoadDataList
                                                            ref={listRef}
                                                            itemData={listData}
                                                            className="List"
                                                            height={height}
                                                            itemCount={listData.length}
                                                            itemSize={getSize}
                                                            width={width}
                                                        >
                                                            {({ data, index, style }) => {
                                                                // console.log('dates :', data);
                                                                return (
                                                                    <div style={style} className={classes.addPadding}>
                                                                        <Row
                                                                            data={data}
                                                                            index={index}
                                                                            setSize={setSize}
                                                                            windowWidth={windowWidth}
                                                                            showUserActivity={props.showPdfExport}
                                                                        />
                                                                    </div>

                                                                )
                                                            }}
                                                            {/* {Row} */}
                                                        </LoadDataList>
                                                    )}
                                                </AutoSizer>
                                            </div>
                                        </div>
                                        : (
                                            listData && listData.length == 0 ?
                                                <>  {renderNoRecordsUI()}</>

                                                : null
                                        )
                                }
                            </>

                            : (
                                props.windowDataList != undefined && props.windowDataList ?
                                    (
                                        dates && dates.length > 0 ?
                                            (
                                                <div style={{ display: 'flex', height: '100vh' }}>
                                                    <div style={{ flex: '1 1 auto' }}>
                                                        <AutoSizer>
                                                            {({ height, width }) => (
                                                                <LoadDataList
                                                                    ref={listRef}
                                                                    itemData={dates}
                                                                    className="List"
                                                                    height={height}
                                                                    itemCount={dates.length}
                                                                    itemSize={getSize}
                                                                    width={width}
                                                                >
                                                                    {({ data, index, style }) => {
                                                                        // console.log('dates :', data);
                                                                        return (
                                                                            <div style={style} className={classes.addPadding}>
                                                                                <DateRow
                                                                                    data={data}
                                                                                    index={index}
                                                                                    setSize={setSize}
                                                                                    windowWidth={windowWidth}
                                                                                    showUserActivity={props.showPdfExport}
                                                                                />
                                                                            </div>
                                                                        )
                                                                    }}
                                                                    {/* {Row} */}
                                                                </LoadDataList>
                                                            )}
                                                        </AutoSizer>
                                                    </div>
                                                </div>
                                            )
                                            : (
                                                dates && dates.length == 0 ?
                                                    <>  {renderNoRecordsUI()}</>
                                                    : null
                                            )
                                    )
                                    :
                                    props.virtuso != undefined && props.virtuso == true ?
                                        (
                                            dates && dates.length > 0 ?
                                                (
                                                    <div style={{ display: 'flex', height: '70vh' }}>
                                                        <div style={{ flex: '1 1 auto' }}>
                                                            <Virtuoso
                                                                style={{ height: '100%' }}
                                                                data={dates}
                                                                // endReached={loadMore}
                                                                increaseViewportBy={300}
                                                                itemContent={rowItemContent}
                                                            />
                                                        </div>
                                                    </div>
                                                )
                                                : dates && dates.length == 0 ?
                                                    <>  {renderNoRecordsUI()}</>
                                                    : null
                                        )
                                        :
                                        <>
                                            {dates && dates.length > 0 ? (
                                                dates.map((date, index) => {
                                                    let list = [...listData];

                                                    let data = list.filter((x) => {
                                                        if (x.actualData.startDateTime !== null) {
                                                            //&& x.actualData.endDateTime !== null
                                                            if (
                                                                moment(date).format('MM/DD/YYY') ==
                                                                moment(
                                                                    x.actualData.startDateTime
                                                                ).format('MM/DD/YYY')
                                                            ) {
                                                                //&& moment(date).format('MM/DD/YYY') <= moment(x.actualData.endDateTime).format('MM/DD/YYY')
                                                                return x;
                                                            }
                                                        } else if (
                                                            date === 'TBD' &&
                                                            x.actualData.startDateTime === null &&
                                                            x.actualData.endDateTime === null
                                                        )
                                                            return x;
                                                    });

                                                    return (
                                                        <React.Fragment key={`row_${index}`}>
                                                            <Accordion
                                                                expanded={expanded[index]}
                                                                onChange={handleChange(index)}>
                                                                {/* expanded={expanded === `panel${index + 1}`} onChange={handleChange(`panel${index + 1}`)} */}
                                                                <AccordionSummary
                                                                    expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />}
                                                                    aria-controls={`panel${index + 1
                                                                        }bh-content`}
                                                                    id={`panel${index + 1}bh-header`}
                                                                    style={{ backgroundColor: themeState.primary.value }}>
                                                                    <Typography
                                                                        sx={{ width: '33%', flexShrink: 0 }}
                                                                        className={classes.accordionHeader}>
                                                                        {date !== 'TBD'
                                                                            ? moment(date).format(
                                                                                'dddd, MMMM D, YYYY'
                                                                            )
                                                                            : date}
                                                                    </Typography>
                                                                </AccordionSummary>
                                                                <AccordionDetails sx={{ marginBottom: '3%' }}>
                                                                    <List className={classes.listContent}>
                                                                        {data &&
                                                                            data.length > 0 &&
                                                                            data.map((item, index) => (
                                                                                <React.Fragment key={`datarow_${index}`}>
                                                                                    <ScheduleRow
                                                                                        key={`datarow_${index}`}
                                                                                        item={item}
                                                                                        index={index}
                                                                                        onCheckSelect={
                                                                                            onCheckSelect
                                                                                        }
                                                                                        handleAddParticipants={
                                                                                            props.handleAddParticipants
                                                                                        }
                                                                                        handleViewParticipants={
                                                                                            props.handleViewParticipants
                                                                                        }
                                                                                        editSubActivityRow={props.editSubActivityRow}
                                                                                        editRow={props.editRow}
                                                                                        viewPage={
                                                                                            props.viewPage
                                                                                        }
                                                                                        deleteSubActivityRow={props.deleteSubActivityRow}
                                                                                        showUsersList={
                                                                                            props.showUsersList
                                                                                        }
                                                                                        handleAddSubActivity={props.handleAddSubActivity}
                                                                                        showSubActivity={props.showSubActivity}
                                                                                        modPermission={
                                                                                            props.modPermission
                                                                                        }
                                                                                        onRowToggleChange={
                                                                                            props.onRowToggleChange
                                                                                        }
                                                                                        showUserActivity={props.showPdfExport}
                                                                                    />
                                                                                </React.Fragment>
                                                                            ))}
                                                                    </List>
                                                                </AccordionDetails>
                                                            </Accordion>
                                                        </React.Fragment>
                                                    );
                                                })
                                            ) : (
                                                dates && dates.length == 0 ?
                                                    <>  {renderNoRecordsUI()}</>
                                                    : null
                                            )}
                                        </>
                            )
                    }
                </Box>
            </Box>
            {
                props.windowDataList == undefined && props.pagingInfo && props.isPage &&
                    props.pagingInfo.noOfPages > 1 ? (
                    <Box
                        sx={{
                            p: 2,
                            display: 'flex',
                            width: '100%',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}>
                        <Paging
                            pagingInfo={props.pagingInfo}
                            handlePageChange={props.handlePageChange}
                        />
                    </Box>
                ) : null
            }
        </Box >
    );
}